// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1CFYj","label":"Category_label__29Ggd","content":"Category_content__3h1LI","header":"Category_header__3uczF","location":"Category_location__1hq5T"};